<template>
  <span v-if="visibleRating">
    <a :href="reviewListUrl" v-if="visibleReviewLink" target="_blank">
      <span
        :class="pointClassName"
        :aria-label="scoreMessage"
        class="point"
      ></span>
    </a>
    <nuxt-link v-else-if="visibleAnchorLink" v-scroll-to="anchorLink" to>
      <span
        :class="pointClassName"
        :aria-label="scoreMessage"
        class="point"
      ></span>
    </nuxt-link>
    <span
      :class="pointClassName"
      :aria-label="scoreMessage"
      v-else
      class="point"
    ></span>
    <span v-if="enableScore"> {{ scoreMessage }}</span>
  </span>
</template>

<script>
import { methods } from '@/utils/methods'
export default {
  props: {
    rating: {
      type: Number,
      default: 5.0
    },
    enableScore: {
      type: Boolean,
      default: false
    },
    placeId: {
      type: String,
      default: ''
    },
    enableReviewLink: {
      type: Boolean,
      default: false
    },
    anchorLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    visibleRating() {
      if (this.rating >= 1 && this.rating <= 5) {
        return true
      }
      return false
    },
    visibleReviewLink() {
      return this.enableReviewLink && this.placeId
    },
    visibleAnchorLink() {
      return this.anchorLink !== ''
    },
    scoreMessage() {
      return this.rating + '点'
    },
    pointClassName() {
      if (this.rating >= 1 && this.rating <= 5) {
        return 'point' + Math.floor(this.rating)
      }
      return ''
    },
    reviewListUrl() {
      if (!this.placeId) return ''
      return methods.getReviewListUrl(this.placeId)
    }
  }
}
</script>
